/**
 * Copyright (c) 2010-2023 California CAD Solutions, Inc. Licensed subject
 * to an End-User License Agreement included in a separate file named EULA.txt
 * that is distributed with this file.
 */
import { MapCommand } from '../map-command.class';
import { WindowRefService } from '../../../../core/ui/services/windowRef.service';

export class LaunchUrlCommand extends MapCommand {

    invoke() {
        const windowRef: WindowRefService = this.deps['windowRef'];
        const url = this.attributes['url'];
        if (url) {
            windowRef.nativeWindow.open(url, '_blank', '', false);
        }
        this.deactivate$.next();
    }

    protected onCommandInit() {
        super.onCommandInit();
    }

    protected onAttributesSet() {
        super.onAttributesSet();

        if (this.attributes?.hasOwnProperty('svgSrc')) {
            const svgSrc = this.attributes['svgSrc'];
            const svgName = svgSrc.split('/').pop().split('.').shift();
            // const svgPath = `${ this.baseHref }/${ svgSrc }`.replace('//', '/');
            this.deps['iconRegistry'].addSvgIcon(
                svgName,
                this.deps['sanitizer'].bypassSecurityTrustResourceUrl(svgSrc)
            );

        }
    }
}
